<app-navbar [navList]="navList" [search]="true" (searchEvent)="searchValue.set($event)" i18n-searchPlaceholder
    searchPlaceholder="Cerca tra le domande frequenti..."></app-navbar>

<div class="qai-content-box overflow-auto">

    <div class="mb-4">
        <h4 i18n>Domande Frequenti</h4>
    </div>

    @for (faq of filteredFaqList(); track faq.id) {
    <div ngbAccordion class="mb-3 faq-accordion">
        <div ngbAccordionItem class="faq-item">
            <div ngbAccordionHeader>
                <button class="faq-question" ngbAccordionButton [innerHTML]="faq.questionHtml | safeHtml"></button>
            </div>
            <div ngbAccordionCollapse>
                <div class="faq-answer" ngbAccordionBody [innerHTML]="faq.answerHtml | safeHtml"></div>
            </div>
        </div>
    </div>
    }
</div>